module.exports = __webpack_public_path__ + "static/media/wmgr_vr_flythrough.d2e3dcae.mp4";